import axios from "axios";
const wizardActions = {
    loadCourses({ commit }) {
        return axios.get('/api/resource-courses')
            .then(({ data }) => commit('setState', { prop: 'courses', value: data }));
    },
    saveData({ commit }, payload){
        return axios.post('/api/save-data',  {
            payload
        }).then(({ data }) => data);
    }
};

export default wizardActions;
